import { Vue } from 'vue-property-decorator'

/**
 * 学習進捗状況の定数定義
 */
export namespace LearningProgress {
  // 未学習
  export const NONE: LearningProgressMaster = {
    code: 'none',
    label: '未学習',
    labelFull: '未学習',
    color: '--color-learning-progress__none__text',
    colorBackGround: '--color-learning-progress__none__background',
  }
  // 例題
  export const EXAMPLE: LearningProgressMaster = {
    code: 'example',
    label: '例題',
    labelFull: '基本例題',
    color: '--color-learning-progress__example__text',
    colorBackGround: '--color-learning-progress__example__background',
  }
  // A
  export const LEVEL_A: LearningProgressMaster = {
    code: 'a',
    label: 'A',
    labelFull: 'A類問題',
    color: '--color-learning-progress__a__text',
    colorBackGround: '--color-learning-progress__a__background',
  }
  // B
  export const LEVEL_B: LearningProgressMaster = {
    code: 'b',
    label: 'B',
    labelFull: 'B類問題',
    color: '--color-learning-progress__b__text',
    colorBackGround: '--color-learning-progress__b__background',
  }
  // C
  export const LEVEL_C: LearningProgressMaster = {
    code: 'c',
    label: 'C',
    labelFull: 'C類問題',
    color: '--color-learning-progress__c__text',
    colorBackGround: '--color-learning-progress__c__background',
  }
  // 学習完了
  export const COMPLETE: LearningProgressMaster = {
    code: 'complete',
    label: '学習完了',
    labelFull: '学習完了',
    color: '--color-learning-progress__complete__text',
    colorBackGround: '--color-learning-progress__complete__background',
  }
  // 学習進捗状況一覧
  export const LIST: LearningProgressMaster[] = [NONE, EXAMPLE, LEVEL_A, LEVEL_B, LEVEL_C, COMPLETE]

  // 学習レベルの定数定義
  const LEVELS = {
    EXAMPLE: 0,
    LEVEL_A: 1,
    LEVEL_B: 2,
    LEVEL_C: 3,
  }

  /**
   * コードから該当する定数を見つけて返す
   *
   * @param code 学習進捗状況コード
   * @returns 学習進捗状況マスタ
   */
  export function findByCode(code: string | null): LearningProgressMaster {
    // コードがnullの場合、デフォルト値を返す
    if (!code) {
      return LearningProgress.NONE
    }
    const learningProgress = LearningProgress.LIST.find((level) => {
      return level.code === code
    })
    // 該当値がない場合エラー出力、デフォルト値を返す
    if (!learningProgress) {
      Vue.prototype.$logger.error('該当するコードがありません')
      return LearningProgress.NONE
    }
    return learningProgress
  }

  /**
   * 学習レベルから学習進捗マスターを引き当てて返す
   *
   * @param level 学習レベル
   * @returns 学習レベルマスター
   */
  export function findByLevel(level: number): LearningProgressMaster {
    switch (level) {
      case LEVELS.EXAMPLE:
        return EXAMPLE
      case LEVELS.LEVEL_A:
        return LEVEL_A
      case LEVELS.LEVEL_B:
        return LEVEL_B
      case LEVELS.LEVEL_C:
        return LEVEL_C
      default:
        // 該当値がない場合エラー出力、デフォルト値を返す
        Vue.prototype.$logger.error('該当するレベルがありません')
        return LEVEL_B
    }
  }

  /**
   * 学習進捗状況マスタの型定義
   */
  export type LearningProgressMaster = {
    /** コード */
    code: string
    /** ラベル */
    label: string
    /** ラベル全文 */
    labelFull: string
    /** css 文字色 */
    color: string
    /** css 背景色 */
    colorBackGround: string
  }
}
